import { useContext, useEffect, useState } from "react";

import Toastify from "toastify-js";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";

import { Link } from "react-router-dom";
import { IoChevronBack } from "react-icons/io5";
import BookingPanel from "./components/BookingPanel";
import fetchDataTrace from "../../../services/fetchDataTrace";
import { AuthContext } from "../../../contexts/AuthContext";
import PageHeader from "../../../components/shared/PageHeader";
import { pusher } from "../../..";

export default function NewCalendar() {
  const { user, token, expire } = useContext(AuthContext);

  const [bookings, setBookings] = useState([]);
  const [selected, setSelected] = useState(false);
  const [showPanel, setShowPanel] = useState(false);

  const renderEventContent = (eventInfo: any) => {
    return (
      <>
        {eventInfo?.event?._def?.extendedProps?.status === "Unconfirmed" ? (
          <button
            onClick={() => {
              setSelected(eventInfo?.event?._def);
              setShowPanel(true);
            }}
            className="bg-red-100 p-1 w-full hover:bg-red-200 "
          >
            {eventInfo.event.title
              ? eventInfo.event.title
              : eventInfo?.event?._def?.extendedProps?.vehicle}
          </button>
        ) : (
          <button
            onClick={() => {
              setSelected(eventInfo?.event?._def);
              setShowPanel(true);
            }}
            className="bg-green-100 p-1 w-full hover:bg-green-200 "
          >
            {eventInfo.event.title
              ? eventInfo.event.title
              : eventInfo?.event?._def?.extendedProps?.vehicle}
          </button>
        )}
      </>
    );
  };

  const handleFetchBookings = async () => {
    const uri = `bookings/sites/${user?.site?._id}`;
    const data = await fetchDataTrace({ uri, token, expire });
    setBookings(data?.payload);
  };

  useEffect(() => {
    handleFetchBookings();
    const book = pusher.subscribe(`booking`);
    book.bind("sent", function (data: any) {
      handleFetchBookings();

      Toastify({
        text: `New Booking Created`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "#16A34A",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    book.bind("confirm", function (data: any) {
      handleFetchBookings();
    });

    return () => {
      pusher.unsubscribe("booking");
    };
  }, []);

  useEffect(() => {
    handleFetchBookings();
  }, []);

  return (
    <div className="flex flex-col border border-gray-300 mx-4 rounded-lg mt-2 bg-white">
      <div className="">
        <PageHeader
          title="Bookings"
          subtitle="View recent bookings in calendar"
          tag="List"
          actions={
            <Link to="/bookings" className="flex justify-center items-center">
              <IoChevronBack />
              Back
            </Link>
          }
        />

        <div className="m-4">
          <FullCalendar
            plugins={[dayGridPlugin]}
            events={bookings}
            initialView="dayGridMonth"
            eventContent={renderEventContent}
          />
        </div>
        <BookingPanel
          isVisible={showPanel}
          setVisible={setShowPanel}
          selected={selected}
        />
      </div>
    </div>
  );
}
